import { render, staticRenderFns } from "./GenderRatioChart.vue?vue&type=template&id=541d7ce0&scoped=true&"
import script from "./GenderRatioChart.vue?vue&type=script&lang=ts&"
export * from "./GenderRatioChart.vue?vue&type=script&lang=ts&"
import style0 from "./GenderRatioChart.vue?vue&type=style&index=0&id=541d7ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d7ce0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VFlex,VRow})
